import { render, staticRenderFns } from "./memoInfo.vue?vue&type=template&id=03843e37&scoped=true"
import script from "./memoInfo.vue?vue&type=script&lang=js"
export * from "./memoInfo.vue?vue&type=script&lang=js"
import style0 from "./memoInfo.vue?vue&type=style&index=0&id=03843e37&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03843e37",
  null
  
)

export default component.exports